$(function($, _unitb) {

    var urlLib = {}; 
    
    urlLib.addParameter = function(url, parameterName, parameterValue){

        function _addParam(all, param, value) {
            if (all == "") {
                all = "?";
            }
            else {
                all += "&";
            }
            all += param + "=" + (value ? value : '');

            return all;
        }

        var baseUrl,
            urlhash,
            hashIndex,
            sourceUrl,
            newQueryString = "",
            parameters;

            hashIndex = url.indexOf('#');
            urlhash = hashIndex > 0 ? url.substring(hashIndex) : "";

            sourceUrl = hashIndex > 0 ? url.substring(0, hashIndex) : url;
    
            baseUrl = sourceUrl.split("?")[0];
            parameters = sourceUrl.substring(baseUrl.length + 1).split("&");
    
        for (var i=0; (i < parameters.length); i++)
        {
            var parameterParts = parameters[i].split("=");
            if (parameterParts[0] && !(parameterParts[0] == parameterName))
            {
                newQueryString = _addParam(newQueryString, parameterParts[0], parameterParts[1]);
            }
        }

        newQueryString = _addParam(newQueryString, parameterName, parameterValue);

        return baseUrl + newQueryString + urlhash;
    };

    window.unitb = $.extend(true, {}, window.unitb, { url: urlLib });
}($, window.unitb));